import {ActionTree} from "vuex";
import {PartnerConnectionFilter, PartnersConnectionsState} from "@/store/settings/partners_connections/types";
import {RootState} from "@/store/types";
import Axios from "axios";
import {directDownload} from "@/utils/download-helper";

export const actions: ActionTree<PartnersConnectionsState, RootState> = {
  getPartnersConnections: ({ commit }, data) => {
    commit('setLoading', true);
    return new Promise((resolve, reject) => {
      Axios({ url: '/acapi/partners/connections', params: data })
        .then(resp => {
          commit('setPartnersConnections', resp.data.connections);
          resolve(resp);
        })
        .catch(err => {
          reject(err);
        })
        .finally(() => commit('setLoading', false));
    })
  },
  exportPartnersConnections: ({ }, data: PartnerConnectionFilter) => {
    return directDownload('/acapi/partners/connections/export', data);
  },
};